export const TZ_EST = 'Eastern Standard Time';
